module.exports = __webpack_public_path__ + "img/envelope-close.6012d195.png";